import React from "react";
import { CircularProgress } from "@material-ui/core";

/**
 * Centered circular spinner used in place of "Loading…" text across
 * the Profit Tracker. Pass `label` to show a caption below.
 */
export default function Spinner({ label, size = 40, minHeight = 160 }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 14,
        padding: "40px 16px",
        minHeight,
        color: "var(--pt-muted)",
      }}
    >
      <CircularProgress size={size} style={{ color: "#2d5a3d" }} thickness={4} />
      {label && (
        <div
          style={{
            fontSize: 13,
            color: "var(--pt-muted)",
            fontFamily: "'DM Sans', system-ui, sans-serif",
            letterSpacing: 0.2,
          }}
        >
          {label}
        </div>
      )}
    </div>
  );
}
